import {
    GENDER_UNISEX_CODE,
    GENDER_KIDS_CODE,
    GENDER_MEN_CODE,
    GENDER_WOMEN_CODE,
    GENDER_ID_BOYS,
    GENDER_ID_GIRLS,
    GENDER_ID_MEN,
    GENDER_ID_WOMEN,
} from 'constants/gender';
import {ActiveFilterItemType} from 'reducers/category/activeFilters/activeFiltersType';

type GenderFilterItemType = {
    ids: number[];
    code: number;
};

const GENDER_FILTERS: GenderFilterItemType[] = [
    {
        ids: [GENDER_ID_MEN],
        code: GENDER_MEN_CODE,
    },
    {
        ids: [GENDER_ID_WOMEN],
        code: GENDER_WOMEN_CODE,
    },
    {
        ids: [GENDER_ID_BOYS, GENDER_ID_GIRLS],
        code: GENDER_KIDS_CODE,
    },
    {
        ids: [GENDER_ID_BOYS],
        code: GENDER_KIDS_CODE,
    },
    {
        ids: [GENDER_ID_GIRLS],
        code: GENDER_KIDS_CODE,
    },
    {
        ids: [],
        code: GENDER_UNISEX_CODE,
    },
];

/**
 * Get gender code by filter list
 * @param {ActiveFilterItemType[]} filters - active filters
 * @return {number | null} - gender code
 */
export const getGenderFromFilters = (filters: ActiveFilterItemType[]): number | null => {
    const ids = filters.map(({value_id: id}) => id);

    const gender = GENDER_FILTERS.find(item =>
        item.ids.every(id => ids.length === item.ids.length && ids.includes(id)),
    );

    return gender ? gender.code : null;
};
